import { styled } from 'styled-components';
import THEME from '../theme.js';
const Well = styled.div `
  border-radius: 3px;
  border: 1px solid lightgrey;
  background-color: #f9f9f9;
  padding: ${THEME.GRID_SPACING}px;
`;
export default Well;
//# sourceMappingURL=Well.js.map